"use client";

import {
  BadmintonScorecard,
  BasketballScorecard,
  CricketScorecard,
  FootballScorecard,
  PadelScorecard,
  PickleballScorecard,
  type ScorecardVariant,
  SnookerScorecard,
  SquashScorecard,
  TableTennisScorecard,
  TennisScorecard,
  ThrowballScorecard,
  VolleyballScorecard,
} from "./scorecards";

type ScorecardParticipant = {
  id: string;
  displayName: string;
  avatarUrl: string | null;
  username: string | null;
};

type ActivityScorecardProps = {
  activityId: string;
  data: Record<string, unknown> | null;
  participants: ScorecardParticipant[];
  variant?: ScorecardVariant;
};

export function ActivityScorecard({
  activityId,
  data,
  participants,
  variant = "feed",
}: ActivityScorecardProps) {
  const normalizedId = activityId.toLowerCase().replace(/[^a-z]/g, "");

  switch (normalizedId) {
    // Racket sports
    case "tennis":
      return (
        <TennisScorecard
          data={data as Parameters<typeof TennisScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "badminton":
      return (
        <BadmintonScorecard
          data={data as Parameters<typeof BadmintonScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "tabletennis":
      return (
        <TableTennisScorecard
          data={data as Parameters<typeof TableTennisScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "squash":
      return (
        <SquashScorecard
          data={data as Parameters<typeof SquashScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "padel":
      return (
        <PadelScorecard
          data={data as Parameters<typeof PadelScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "pickleball":
      return (
        <PickleballScorecard
          data={data as Parameters<typeof PickleballScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );

    // Specialty
    case "snooker":
      return (
        <SnookerScorecard
          data={data as Parameters<typeof SnookerScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );

    // Team sports
    case "basketball":
      return (
        <BasketballScorecard
          data={data as Parameters<typeof BasketballScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "football":
      return (
        <FootballScorecard
          data={data as Parameters<typeof FootballScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "volleyball":
      return (
        <VolleyballScorecard
          data={data as Parameters<typeof VolleyballScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "throwball":
      return (
        <ThrowballScorecard
          data={data as Parameters<typeof ThrowballScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    case "cricket":
      return (
        <CricketScorecard
          data={data as Parameters<typeof CricketScorecard>[0]["data"]}
          participants={participants}
          variant={variant}
        />
      );
    default:
      return null;
  }
}
